import { render, staticRenderFns } from "./project_tree_table.vue?vue&type=template&id=5861737d&scoped=true"
import script from "./project_tree_table.vue?vue&type=script&lang=js"
export * from "./project_tree_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861737d",
  null
  
)

export default component.exports